module.exports = require("./so-KE.d.ts");